export const apiRoutes = {
    KEYCLOAK: {
        account: '/realms/master/account',
        token: '/realms/maasify/protocol/openid-connect/token',
        logout: '/realms/maasify/protocol/openid-connect/logout',
        login: '/realms/maasify/protocol/openid-connect/auth?response_type=code&client_id={client}&redirect_uri={redirect}',
        register: '/realms/maasify/protocol/openid-connect/registrations?response_type=code&client_id={client}&redirect_uri={redirect}'
    }
};
